export interface PostItem {
  id: string;
  title: string;
  categorySlug: string;
  categoryName: string;
  excerpt: string;
  cover: string;
  author: string;
  publishedAt: string;
  readTime: string;
  views: number;
  heat: number;
  likes: number;
  comments: number;
  tags: string[];
  content: string[];
}

export const categories = [
  {
    slug: "star",
    name: "明星八卦",
    icon: "ri-star-smile-line",
    description: "娱乐圈最新动态、恋情曝光、剧组花絮，第一口瓜先给你。",
    count: 1284,
  },
  {
    slug: "society",
    name: "社会热点",
    icon: "ri-fire-line",
    description: "全城关注的社会事件与温情瞬间，看见真实的人间百态。",
    count: 967,
  },
  {
    slug: "industry",
    name: "行业秘闻",
    icon: "ri-building-2-line",
    description: "大厂、直播、新能源，行业水面之下的那些门道。",
    count: 742,
  },
  {
    slug: "workplace",
    name: "职场爆料",
    icon: "ri-briefcase-4-line",
    description: "绩效潜规则、裸辞账单、办公室暗流，打工人的真实图鉴。",
    count: 613,
  },
];

export const topics = [
  "顶流塌房",
  "恋情实锤",
  "大厂裁员",
  "直播内斗",
  "综艺停录",
  "绩效潜规则",
  "裸辞创业",
  "新能源价格战",
  "邻里纠纷",
  "城市温度",
  "剧组路透",
  "行业内幕",
];

export const editors = [
  { name: "瓜田老农", role: "首席爆料官", avatar: "https://readdy.ai/api/search-image?query=Warm%20editorial%20portrait%20silhouette%20of%20a%20mysterious%20figure%20in%20amber%20lighting%2C%20abstract%20stylized%20avatar%20illustration%2C%20deep%20crimson%20and%20gold%20tones%2C%20no%20readable%20text&width=200&height=200&seq=gossip-editor-01&orientation=squarish" },
  { name: "深夜情报局", role: "热点追踪组", avatar: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20magazine%20avatar%20illustration%20with%20warm%20golden%20bokeh%20and%20deep%20amber%20gradient%2C%20editorial%20mystery%20mood%2C%20soft%20glowing%20particles%2C%20no%20readable%20text&width=200&height=200&seq=gossip-editor-02&orientation=squarish" },
  { name: "内幕显微镜", role: "行业调查员", avatar: "https://readdy.ai/api/search-image?query=Abstract%20stylized%20editorial%20avatar%20with%20warm%20crimson%20and%20caramel%20gradient%20lighting%2C%20moody%20investigation%20atmosphere%2C%20soft%20bokeh%20particles%2C%20no%20readable%20text&width=200&height=200&seq=gossip-editor-03&orientation=squarish" },
];

export const posts: PostItem[] = [
  {
    id: "star-001",
    title: "顶流男星深夜聚餐被拍，同框神秘友人疑似恋情稳定",
    categorySlug: "star",
    categoryName: "明星八卦",
    excerpt:
      "昨夜十一点，有网友在城东某私房菜馆偶遇顶流男星。据现场目击者描述，两人用餐近三小时，期间互动自然，离场时还刻意分开走。这已经是本月第二次被拍到同框……",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20editorial%20photograph%20of%20a%20dimly%20lit%20upscale%20restaurant%20table%20for%20two%20with%20warm%20candlelight%2C%20blurred%20silhouettes%20in%20background%2C%20deep%20amber%20and%20crimson%20tones%2C%20cinematic%20bokeh%2C%20magazine%20atmosphere%2C%20no%20readable%20text&width=800&height=600&seq=gossip-cover-01&orientation=landscape",
    author: "瓜田老农",
    publishedAt: "2026-09-12",
    readTime: "4 分钟",
    views: 128400,
    heat: 9860,
    likes: 3421,
    comments: 587,
    tags: ["顶流塌房", "恋情实锤", "剧组路透"],
    content: [
      "昨夜十一点，有网友在城东某私房菜馆偶遇顶流男星。据现场目击者描述，两人用餐近三小时，期间互动自然，离场时还刻意分开走。这已经是本月第二次被拍到同框，网友的侦探雷达瞬间拉满。",
      "从曝光的照片来看，餐厅灯光昏暗，两人坐在靠窗的位置。有细心的网友指出，桌上摆着两杯同款饮品，其中一杯加了三份糖——而这恰好是男星此前采访里提到过的口味。",
      "有意思的是，男星工作室至今没有回应。按照以往节奏，遇到不实传闻通常当天就会发声明，而这次已经沉默超过二十小时。这个'异常安静'本身，就成了粉丝圈里新一轮讨论的燃料。",
      "不过也有理性网友提醒，同框不等于实锤，聚餐也可能是工作往来。吃瓜可以，别上头，等一个正式回应再下结论也不迟。",
    ],
  },
  {
    id: "society-002",
    title: "地铁司机一个举动冲上热搜，百万网友点赞：这才是城市温度",
    categorySlug: "society",
    categoryName: "社会热点",
    excerpt:
      "早高峰的地铁站里，一位老人独自站在拥挤的站台边缘。列车进站前，司机通过广播轻声提醒了三遍，随后又临时延长了停靠时间。这段不到一分钟的监控画面，今天刷爆了朋友圈……",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20night%20photograph%20of%20an%20empty%20modern%20subway%20station%20platform%20with%20warm%20golden%20lights%20reflecting%20on%20polished%20floor%2C%20long%20exposure%20motion%20blur%2C%20dramatic%20urban%20atmosphere%2C%20deep%20amber%20tones%2C%20no%20readable%20text&width=800&height=600&seq=gossip-cover-02&orientation=landscape",
    author: "深夜情报局",
    publishedAt: "2026-09-12",
    readTime: "3 分钟",
    views: 96400,
    heat: 8210,
    likes: 5210,
    comments: 742,
    tags: ["城市温度", "社会热点"],
    content: [
      "早高峰的地铁站里，一位老人独自站在拥挤的站台边缘。列车进站前，司机通过广播轻声提醒了三遍，随后又临时延长了停靠时间。这段不到一分钟的监控画面，今天刷爆了朋友圈。",
      "站台工作人员事后回忆，当时正值客流最高峰，老人听力不太好，一直没注意到脚下黄线。司机在驾驶室透过监控发现后，先是用广播提醒，见老人没反应，又特意减速进站。",
      "'其实每天都会遇到需要照顾的乘客，只是这次被镜头记录下来了。'司机在采访里说得很平淡。但正是这份平淡，让无数网友破防——原来城市的温度，藏在这些没人注意的细节里。",
      "评论区里，有人说想起了自己家里的老人，有人说下次坐地铁也要多留意身边的人。一个善意的小举动，正在被更多人接力。",
    ],
  },
  {
    id: "industry-003",
    title: "某头部直播公司内部大调整，多位元老主播集体出走内幕",
    categorySlug: "industry",
    categoryName: "行业秘闻",
    excerpt:
      "据多位业内人士透露，这家曾经占据半壁江山的直播公司，近期正在经历一场静默的人事地震。三位签约五年以上的元老级主播陆续停播，而官方口径始终是'正常调整'……",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20photograph%20of%20a%20modern%20live%20streaming%20studio%20with%20neon%20accents%2C%20ring%20lights%2C%20empty%20streaming%20desk%20setup%2C%20warm%20orange%20and%20red%20glow%2C%20cinematic%20depth%20of%20field%2C%20crisp%20editorial%20look%2C%20no%20readable%20text&width=800&height=600&seq=gossip-cover-03&orientation=landscape",
    author: "内幕显微镜",
    publishedAt: "2026-09-11",
    readTime: "6 分钟",
    views: 87300,
    heat: 7640,
    likes: 2180,
    comments: 466,
    tags: ["直播内斗", "行业内幕", "大厂裁员"],
    content: [
      "据多位业内人士透露，这家曾经占据半壁江山的直播公司，近期正在经历一场静默的人事地震。三位签约五年以上的元老级主播陆续停播，而官方口径始终是'正常调整'。",
      "知情人士表示，导火索是新一轮的流量分配改革。过去头部主播能拿到的推荐权重被大幅压缩，资源开始向中腰部侧重。'简单说，就是把蛋糕重新切了一遍。'",
      "更微妙的是签约条款的变化。有主播透露，新合同里增加了更严格的独家排他要求，同时降低了保底。几位元老显然不愿意接受，谈判陷入僵持。",
      "这场调整最终会走向何方，目前还没有定论。但可以确定的是，直播行业'一家独大'的时代正在过去，内容质量和用户信任，才是更长久的护城河。",
    ],
  },
  {
    id: "workplace-004",
    title: "大厂员工匿名爆料：绩效季的潜规则，看完我沉默了",
    categorySlug: "workplace",
    categoryName: "职场爆料",
    excerpt:
      "又到绩效季。一位在某大厂工作六年的员工选择匿名发声，讲述了他亲眼看到的那些'不能说的规则'。从强制分布到背对背打分，每一句都戳中打工人的心……",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20editorial%20photograph%20of%20a%20modern%20corporate%20office%20at%20dusk%2C%20empty%20glass%20meeting%20room%2C%20warm%20desk%20lamp%20glow%2C%20papers%20and%20coffee%20cup%20on%20desk%2C%20deep%20amber%20tones%2C%20cinematic%20shallow%20depth%20of%20field%2C%20no%20readable%20text&width=800&height=600&seq=gossip-cover-04&orientation=landscape",
    author: "深夜情报局",
    publishedAt: "2026-09-11",
    readTime: "5 分钟",
    views: 76200,
    heat: 6980,
    likes: 4120,
    comments: 938,
    tags: ["绩效潜规则", "职场爆料"],
    content: [
      "又到绩效季。一位在某大厂工作六年的员工选择匿名发声，讲述了他亲眼看到的那些'不能说的规则'。从强制分布到背对背打分，每一句都戳中打工人的心。",
      "'最让人难受的不是结果，而是过程。'他写道，部门必须凑够一定比例的待改进名额，有时候明明大家都做得不错，也要有人'被平均'。",
      "他提到一个细节：真正拉开差距的，往往不是加班时长，而是谁更懂得让关键的人看见自己的价值。'埋头干活没问题，但要记得抬头。'",
      "帖子最后，他没有抱怨，只写了一句话：绩效是公司的管理工具，但你的成长不该被一个等级定义。这句话，被顶到了评论区第一。",
    ],
  },
  {
    id: "star-005",
    title: "昔日天后回归舞台，彩排照流出造型惊艳全场",
    categorySlug: "star",
    categoryName: "明星八卦",
    excerpt:
      "消失在大众视野近三年的天后，被曝将压轴回归某音乐节。昨日一组彩排现场照流出，造型团队几乎是顶配阵容，舞台灯光设计更是斥资七位数……",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20concert%20stage%20with%20warm%20golden%20spotlights%20beaming%20through%20haze%2C%20empty%20microphone%20stand%20on%20stage%2C%20deep%20crimson%20and%20gold%20tones%2C%20cinematic%20atmosphere%2C%20editorial%20music%20photography%2C%20no%20readable%20text&width=800&height=600&seq=gossip-cover-05&orientation=landscape",
    author: "瓜田老农",
    publishedAt: "2026-09-10",
    readTime: "3 分钟",
    views: 65100,
    heat: 6120,
    likes: 2890,
    comments: 341,
    tags: ["综艺停录", "剧组路透"],
    content: [
      "消失在大众视野近三年的天后，被曝将压轴回归某音乐节。昨日一组彩排现场照流出，造型团队几乎是顶配阵容，舞台灯光设计更是斥资七位数。",
      "从照片来看，她一身暗金刺绣长裙，气场全开。有工作人员透露，这次回归准备了全新编曲，其中两首经典作品会做颠覆性改编。",
      "粉丝的反应也很有意思，超话里清一色的'等到了'。三年的时间没有冲淡热爱，反而让这份期待更沉甸甸。",
      "至于回归之后是否会发新专辑，团队暂未回应。但光是这场音乐节，就已经卖到一票难求。",
    ],
  },
  {
    id: "society-006",
    title: "小区物业费涨价风波：业主群里吵翻了，专家这样说",
    categorySlug: "society",
    categoryName: "社会热点",
    excerpt:
      "一纸涨价通知贴在电梯口，业主群瞬间炸锅。有人算了一笔账，一年多出来的费用够全家旅游一趟；物业则拿出成本明细，说涨价实属无奈。这场拉锯，到底谁有理……",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20evening%20photograph%20of%20modern%20residential%20apartment%20buildings%20with%20glowing%20windows%20at%20twilight%2C%20trees%20along%20a%20quiet%20street%2C%20amber%20and%20dusty%20rose%20tones%2C%20cinematic%20editorial%20style%2C%20no%20readable%20text&width=800&height=600&seq=gossip-cover-06&orientation=landscape",
    author: "深夜情报局",
    publishedAt: "2026-09-10",
    readTime: "4 分钟",
    views: 54300,
    heat: 5310,
    likes: 1760,
    comments: 612,
    tags: ["邻里纠纷", "社会热点"],
    content: [
      "一纸涨价通知贴在电梯口，业主群瞬间炸锅。有人算了一笔账，一年多出来的费用够全家旅游一趟；物业则拿出成本明细，说涨价实属无奈。",
      "物业给出的理由听起来也算实在：人工成本三年涨了近三成，电梯维保、绿化养护的费用都在往上走，而现行的收费标准还是五年前定的。",
      "业主的顾虑同样合理。有业主提出，既然要涨价，服务标准是不是也该写清楚？电梯广告收入、公共区域出租收益，这些账目又是否公开透明？",
      "社区治理专家在采访中表示，物业费本质上是一场'服务契约'。与其在群里互相指责，不如推动成立业委会，把涨价的依据和服务的标准白纸黑字谈清楚。",
    ],
  },
  {
    id: "industry-007",
    title: "新能源车企价格战背后，供应商的苦日子才刚开始",
    categorySlug: "industry",
    categoryName: "行业秘闻",
    excerpt:
      "终端价格一降再降，消费者拍手叫好，但产业链上游的供应商却在默默承压。一位零部件厂商的销售总监透露，今年被要求降价的邮件，比过去三年加起来还多……",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20photograph%20of%20an%20electric%20vehicle%20charging%20station%20at%20dusk%20with%20sleek%20modern%20cars%2C%20warm%20golden%20lighting%2C%20industrial%20backdrop%2C%20deep%20amber%20tones%2C%20editorial%20automotive%20photography%2C%20no%20readable%20text&width=800&height=600&seq=gossip-cover-07&orientation=landscape",
    author: "内幕显微镜",
    publishedAt: "2026-09-09",
    readTime: "6 分钟",
    views: 49800,
    heat: 4870,
    likes: 1430,
    comments: 288,
    tags: ["新能源价格战", "行业内幕"],
    content: [
      "终端价格一降再降，消费者拍手叫好，但产业链上游的供应商却在默默承压。一位零部件厂商的销售总监透露，今年被要求降价的邮件，比过去三年加起来还多。",
      "价格战传导到供应链，最先被压缩的是账期和利润。'订单是多了，但毛利被砍到只剩几个点，做得多亏得多。'他苦笑着说。",
      "更棘手的是技术迭代。车企为了差异化，不断提出新的定制需求，供应商必须跟着投研发，可一旦车型销量不及预期，前期投入就打了水漂。",
      "业内人士认为，行业正在经历一轮残酷的洗牌。活下来的不会是报价最低的，而是那些能把技术沉淀下来、和整车厂形成深度绑定的供应商。",
    ],
  },
  {
    id: "workplace-008",
    title: "95后裸辞开咖啡店一年，账单曝光让人意外",
    categorySlug: "workplace",
    categoryName: "职场爆料",
    excerpt:
      "去年这个时候，他还在写字楼里做设计，如今他是一间十二平米咖啡店的老板。当他把一年来的真实账单晒出来，评论区从'羡慕'变成了'沉默'……",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20warm%20interior%20of%20a%20small%20independent%20coffee%20shop%20with%20wooden%20counter%2C%20hanging%20pendant%20lights%2C%20latte%20on%20counter%2C%20steam%20rising%2C%20amber%20and%20caramel%20tones%2C%20cinematic%20editorial%20photograph%2C%20no%20readable%20text&width=800&height=600&seq=gossip-cover-08&orientation=landscape",
    author: "深夜情报局",
    publishedAt: "2026-09-09",
    readTime: "5 分钟",
    views: 61200,
    heat: 5640,
    likes: 3210,
    comments: 704,
    tags: ["裸辞创业", "职场爆料"],
    content: [
      "去年这个时候，他还在写字楼里做设计，如今他是一间十二平米咖啡店的老板。当他把一年来的真实账单晒出来，评论区从'羡慕'变成了'沉默'。",
      "账单里最扎眼的是房租和人力。十二平米的小店，月租却占了流水的三成；请一个兼职，又吃掉一大块利润。他坦言，前八个月基本是给自己打工。",
      "真正让他撑下来的，是熟客。'有几位客人几乎每天来，点同一种豆子，坐同一个位置。那种被需要的感觉，是上班时从没有过的。'",
      "他说自己并不后悔，但也劝后来人想清楚：创业不是逃离，而是换一种方式承担压力。先把账算明白，再谈热爱。",
    ],
  },
  {
    id: "star-009",
    title: "老牌综艺被曝停录，常驻嘉宾阵容或将大换血",
    categorySlug: "star",
    categoryName: "明星八卦",
    excerpt:
      "陪伴观众走过九季的王牌综艺，近日突然宣布暂停录制。官方给出的理由是'档期协调'，但据知情人士透露，真正的分歧在于常驻嘉宾的合约与分成比例……",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20photograph%20of%20an%20empty%20television%20variety%20show%20set%20with%20colorful%20stage%20lighting%20and%20cameras%2C%20warm%20orange%20red%20glow%2C%20cinematic%20depth%2C%20editorial%20entertainment%20photography%2C%20no%20readable%20text&width=800&height=600&seq=gossip-cover-09&orientation=landscape",
    author: "瓜田老农",
    publishedAt: "2026-09-08",
    readTime: "4 分钟",
    views: 58700,
    heat: 5010,
    likes: 1980,
    comments: 397,
    tags: ["综艺停录", "顶流塌房"],
    content: [
      "陪伴观众走过九季的王牌综艺，近日突然宣布暂停录制。官方给出的理由是'档期协调'，但据知情人士透露，真正的分歧在于常驻嘉宾的合约与分成比例。",
      "这档节目最初的魅力，恰恰在于嘉宾之间自然产生的化学反应。九年过去，有人走红，有人转型，档期和诉求也早已不同。",
      "'观众想看的是熟悉感，但嘉宾想要的是突破。'一位节目编导在社交平台写道，这种矛盾几乎是所有长寿综艺的宿命。",
      "目前节目组尚未公布新一季的阵容。无论换不换人，如何找回最初那份松弛和真诚，才是这档节目真正的考验。",
    ],
  },
];

export const tickerHeadlines = [
  "顶流男星深夜聚餐被拍",
  "地铁司机一个举动冲上热搜",
  "头部直播公司元老主播集体出走",
  "大厂绩效季潜规则曝光",
  "95后裸辞开咖啡店账单公开",
  "老牌综艺被曝暂停录制",
];

export const siteStats = [
  { label: "每日更新", value: "300+", icon: "ri-refresh-line" },
  { label: "累计吃瓜", value: "860万", icon: "ri-eye-line" },
  { label: "活跃瓜友", value: "42万", icon: "ri-group-line" },
  { label: "爆料线索", value: "1.2万", icon: "ri-mail-send-line" },
];